import { ErrorService } from "./error.service";
import { LoggerFactory } from "./log.service";

const logger = new LoggerFactory("debug");
const errorService = new ErrorService(logger);

export const useLogger = (name: string) => logger.getLogger(name);
export const useErrorService = () => errorService;
